import React from 'react';

const ClientContext = React.createContext('client_context');

export const ClientContextProvider = ClientContext.Provider;

export default ClientContext;
